<template>
  <div>
    <el-button type="text" size="small" @click="openSee">
      <slot></slot>
    </el-button>

    <el-dialog
        title="修改产品信息"
        :visible.sync="openStatus"
        width="60%"
        :fullscreen="false"
        :modal-append-to-body="true"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :destroy-on-close="true"
        :before-close="closeSee"
    >
      <div style="padding: 20px;">
        <el-form label-width="120px">
          <el-form-item label="名称">
            <el-input v-model="form.name" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="存货编码">
            <el-input v-model="form.model_code" placeholder="请输入存货编码"></el-input>
          </el-form-item>
          <el-form-item label="是否有条码">
            <el-radio v-model="form.is_bar" :label="1">有</el-radio>
            <el-radio v-model="form.is_bar" :label="0">无</el-radio>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="toSubmit">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  components: {},
  data() {
    return {
      list: [],
      openStatus: false,
      loading: false,
      form: {
        id: '',
        name: '',
        model_code: '',
        is_bar: 1,
      }
    };
  },
  computed: mapState({
    config: (state) => state.config,
  }),
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  mounted() {
  },
  methods: {
    // 筛选
    openSee() {
      const _this = this;
      _this.form = {
        id: _this.id,
        name: '',
        model_code: '',
        is_bar: 1,
      }
      _this.loading = true;
      _this.$api.productUpdateDetail(_this.form)
          .then(res => {
            _this.loading = false;
            _this.openStatus = true;
            _this.form = JSON.parse(JSON.stringify(res.detail))
          })
          .catch(err => {
            _this.loading = false;
          })
    },
    closeSee() {
      const _this = this;
      _this.form = {
        name: '',
        model_code: '',
      }
      _this.openStatus = false;
    },
    toSubmit() {
      const _this = this;
      _this.submitIng = false;
      _this.form.id = _this.id;
      _this.$api.productUpdate(_this.form)
          .then(res => {
            _this.submitIng = false;
            _this.closeSee();
            _this.$emit('finish', res);
            _this.$message.success('修改成功');
          })
          .catch(err => {
            _this.submitIng = false;
            _this.$message.error(err.msg);
          })
    }
  },
};
</script>